export enum DashboardTransferMode {
	ONLY_DASHBOARDS = 'onlyDashboards',
	ONLY_BOOKS = 'onlyBooks',
	MIXED = 'mixed'
}
